import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PopoverArrow, PopoverBody, PopoverHeader } from '@chakra-ui/react';

type Props = {
  bodyOverflow: 'hidden' | 'scroll';
  children: ReactNode;
};

export const NotificationPopOverBodyWrapper = ({ bodyOverflow, children }: Props) => {
  const { t } = useTranslation('shared');
  return (
    <>
      <PopoverHeader
        fontWeight='semibold'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        py={4}
        color='neutral400'
        pl={5}>
        {t('navigation.notifications')}
      </PopoverHeader>
      <PopoverArrow ml={{ base: '15px', md: 'initial' }} />
      <PopoverBody overflow={bodyOverflow}>{children}</PopoverBody>
    </>
  );
};
